import React, { Component } from 'react';
import { Navbar , NavbarBrand } from 'reactstrap';
import Menu from './MenuComponent.js'
import Dishdetail from './DishdetailComponent.js'
import Header from './Header.js'
import Footer from './Footer.js'
import Home from './HomeComponent.js'
import Contact from './ContactComponent.js'
import About from './AboutComponent.js'
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { postComment , fetchDishes, fetchComments, fetchPromos, fetchLeaders, postFeedback} from '../redux/ActionCreators.js'
import { actions } from 'react-redux-form'
import { TransitionGroup, CSSTransition } from 'react-transition-group';

const mapStateToProps = state => {
	return {
	dishes: state.dishes,
    comments: state.comments,
    promotions: state.promotions,
    leaders: state.leaders
	}	
}

const  mapDispatchToProps = dispatch => ({
	postComment : (dishId,rating,author,comment) => dispatch(postComment(dishId,rating,author,comment)),
	fetchDishes : () => {dispatch(fetchDishes())},
	resetFeedbackForm : () => {dispatch(actions.reset('feedback'))},
	fetchComments: () => dispatch(fetchComments()),
  	fetchPromos: () => dispatch(fetchPromos()),
	fetchLeaders: () => dispatch(fetchLeaders()),
	postFeedback : (firstname, lastname, Telno, email, agree, contactType, message) => dispatch(postFeedback(firstname, lastname, Telno, email, agree, contactType, message))
})

class Main extends Component {

  constructor(props){
	  super(props);
  }	
	
  componentDidMount() {
	  this.props.fetchDishes();
	  this.props.fetchComments();
      this.props.fetchPromos();
	  this.props.fetchLeaders();
  }	
  	
  render(){
	  
const HomePage = () => {return(
	console.log(this.props.dishes.dishes),
	 <Home 
              dish={this.props.dishes.dishes.filter((dish) => dish.featured)[0]}
		 	  dishesLoading={this.props.dishes.isLoading}
		 	  dishesErrMess={this.props.dishes.errMess}
              promotion={this.props.promotions.promotions.filter((promo) => promo.featured)[0]}
		 	  promoLoading={this.props.promotions.isLoading}
              promoErrMess={this.props.promotions.errMess}
              leader={this.props.leaders.leaders.filter((leader) => leader.featured)[0]}
		 	  leaderLoading={this.props.leaders.isLoading}
              leaderErrMess={this.props.leaders.errMess}
          />	
)}	  

const DishWithId = ({match}) => {return(
	<Dishdetail dish={this.props.dishes.dishes.filter((dish) => dish.id === parseInt(match.params.dishId))[0]}
		isLoading={this.props.dishes.isLoading}
		errMess={this.props.dishes.errMess}
		 comments={this.props.comments.comments.filter((comment) => comment.dishId === parseInt(match.params.dishId,10))}
		commentsErrMess={this.props.comments.errMess}
		postComment= {this.props.postComment}/>
)}
  return (
    <div>
      	  <Header />
		  <TransitionGroup>
			   <CSSTransition key={this.props.location.key} classNames="page" timeout={300}>
				   <Switch location={this.props.location}>
					  <Route path='/home' component={HomePage} />
					  <Route path='/aboutus' component={() => <About leaders={this.props.leaders} />} />
					  <Route exact path='/menu' component={() => <Menu dishes={this.props.dishes} />} />
					  <Route path='/menu/:dishId' component={DishWithId} />
					   <Route exact path='/contactus' component={() => <Contact resetFeedbackForm={this.props.resetFeedbackForm} postFeedback={this.props.postFeedback}/>} />
					  <Redirect to="/home" />
				  </Switch>
			  </CSSTransition>  
			</TransitionGroup>  
		  <Footer />
    </div>
  )}
}

export default withRouter(connect(mapStateToProps , mapDispatchToProps)(Main))
